import { createRouter, createWebHistory } from 'vue-router';
import HomePage from '/src/views/HomePage.vue';
import ContactPage from '/src/views/ContactPage.vue';

// Definindo as rotas
const routes = [
  {
    path: '/',
    name: 'Home',
    component: HomePage
  },
  {
    path: '/about',
    name: 'About',
    component: ()=> import ('../views/AboutPage.vue')
  },
  {
    path: '/contact',
    name: 'Contact',
    component: ContactPage
  }
];

// Criando o router
const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
});

export default router;